// extracted by mini-css-extract-plugin
export default {"container":"DemoPage_container__mCWlg","title":"DemoPage_title__4Jrlh","description":"DemoPage_description__KrrMZ"};